var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('div',{staticClass:"inner inner--full row5"},[_c('img',{style:({ margin: 'auto', maxWidth: '100%' }),attrs:{"src":"/images/general/incoming-feature.svg","alt":"Incoming Feature"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }